module.exports = __webpack_public_path__ + "static/media/Sec-2_2677_Icon_2_CN.077e13a2.png";